import React, {Component} from 'react'
import TableComp from '../../../components/_utils/table'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import moment from 'moment'
import {Button, Card, Form, notification, Popconfirm, Tooltip} from 'antd'
import Request from '../../../request'

import {connect} from 'react-redux'
import styles from './styles.less'
import {RightsWrapper} from '../../../components/_utils/utils'

// const TabPane = Tabs.TabPane

@Form.create()
class NotAllowedIps extends Component {
    state = {count: 0}
    delete = async (record) => {

        this.setState({load: true})
        let x = await Request.deleteNotAllowedIp({ip: record.ip})

        if (x && !x.error) {

            notification.success({
                message: x.message
            })

            this.table.current.reload()
            this.setState({load: false})


        } else {
            notification.error({message: 'Try again'})
        }


    }
    addAndDelete = async (data) => {

        this.setState({loading: true})

        let x = await Request.addIpToIpsCollection({ip: data.ip})

        if (!x.error) {

            notification.success({message: x.message})

            let y = await Request.deleteNotAllowedIp({ip: data.ip})

            if (!y.error) {
                this.table.current.reload()
                this.setState({loading: false})

            }
        } else {
            notification.error({message: 'Ip not added'})

        }
    }
    deleteAll = async () => {
        this.setState({loading: true})
        let x = await Request.deleteAllNotAllowedIps()

        this.setState({loading: false})


        if (!x.error) {
            notification.success({message: x.message, duration: 10})
            this.table.current.reload()

        } else {
            notification.error({message: 'Try Again'})
        }
    }
    apiRequest = params => {
        return new Promise(async resolve => {
            if (!params.sortField) {
                params.sortField = 'newIps.time'
                params.sortOrder = 'descend'
            }

            let data = await Request.loadAllNotAllowedIps({
                ...params,
                regExFilters: ['newIps.ip']
            })


            this.setState({count: data.total})
            resolve(data)
        })
    }

    constructor(props) {
        super(props)

        this.table = React.createRef()

    }

    async componentDidMount() {

    }

    render() {
        const {count} = this.state

        const columns = [

            {
                title: 'Ip',
                key: 'newIps.ip',
                dataIndex: 'newIps.ip',
                searchTextName: 'ip',
                filterRegex: true,
                render: (val, record) => {

                    return <div>{record && record.newIps.map((v) => {
                        return v.ip
                    })}</div>

                }

            },

            {
                title: 'Time',
                key: 'time',
                dataIndex: 'newIps.ip',
                render: (val, record) => {

                    return <div>{record && record.newIps.map((v) => {
                        return moment(v.time).format('DD/MM/YYYY HH:mm')
                    })}</div>

                }

            },

            {
                title: 'Action',
                key: '_id',
                dataindex: '_id',
                width: 100,
                render: (val, record) => (
                    <React.Fragment>
                        <RightsWrapper myRight={'IpManagement.add'}>
                            <Tooltip title={`Add Ip`}>
                                <Popconfirm
                                    title={`Are you sure to add IP `}
                                    onConfirm={() => this.addAndDelete({ip: record.newIps[0].ip})}
                                    onCancel={() => {
                                    }}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        shape="circle"
                                        size={'small'}
                                        className={styles.btn}
                                        icon="plus"/>

                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                        <RightsWrapper myRight={'IpManagement.delete'}>
                            <Tooltip title={`Delete Ip`}>
                                <Popconfirm
                                    title={`Are you sure to delete this IP `}
                                    onConfirm={() => this.delete({ip: record.newIps[0].ip})}
                                    onCancel={() => {

                                    }}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        shape="circle"
                                        size={'small'}
                                        style={{marginLeft: '5px'}}
                                        icon="delete"/>

                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                    </React.Fragment>
                )
            }
        ]


        return (
            <PageHeaderWrapper title={`NOT ALLOWED IP'S : ${count}`}>
                <Card bordered={true}>
                    <RightsWrapper myRight={'IpManagement.delete'}>
                        <React.Fragment>
                            <Tooltip title={'Delete All Ips'}>

                                <Popconfirm
                                    title={`Are you sure you want to delete all Ips. `}
                                    onConfirm={() => this.deleteAll()}
                                    onCancel={() => {
                                    }}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        type={'primary'}>Delete</Button>

                                </Popconfirm>

                            </Tooltip>
                        </React.Fragment>
                    </RightsWrapper>
                    <TableComp
                        columns={columns}
                        ref={this.table}
                        apiRequest={this.apiRequest}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 50,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />


                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    categories: global.categories,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)((NotAllowedIps))
